import React from "react";
import PubSub from "pubsub-js";
import { css } from "emotion";
import { Dropdown, Input } from "@maxmilhas/hangar-components-atomic/public";
import { item } from "./style";
import { contains, reject, equals } from "ramda";

import "../../../shared/pubsub-triggers";

class StopsDropdown extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        selectedStops: []
      };

      this.onCheckChange = this.onCheckChange.bind(this);
    }

    onCheckChange(event) {
      const isAll = event.target.value === "all";
      const isTargetChecked = event.target.checked;

      if (isTargetChecked) {
        PubSub.publish("dataLayer", {
          event: "gaEvent",
          gaEventCategory: "Ponte aérea max",
          gaEventAction: "Para onde você viaja sempre",
          gaEventLabel: "Interação com Paradas",
          gaEventDetail: event.target.parentElement.querySelector("label").innerText
        });
      }

      let stopsArray = [];

      if (!isAll) {
        const value = parseInt(event.target.value, 10);
        stopsArray = [...this.state.selectedStops];

        if (contains(value, stopsArray) && !isTargetChecked) {
          stopsArray = reject(equals(value), stopsArray);
        } else if (isTargetChecked) {
          stopsArray = [...stopsArray, value];
        }
      }

      this.setState({ selectedStops: stopsArray });
      
      this.props.getValue(stopsArray);
    }

    renderText(selectedStops) {
      let textArray = [];

      const pushText = (value, text) => {
        if ( contains(value, selectedStops) ) {
          textArray.push(text);
        } else if ( selectedStops.length === 0 ) {
          !contains("Todas", textArray) ? textArray.push("Todas") : null;
        }
      }

      pushText(0, "Direto");
      pushText(1, "1 Parada");
      pushText(2, "2 Paradas");
      pushText(3, "3 Paradas");

      return textArray.length === 0 || textArray.length === 4 ? "Todas" : textArray.join(", ");
    }

    render() {
      const { selectedStops } = this.state;

      return (
        <Dropdown shadow={true} label="Paradas" text={this.renderText(selectedStops)} role="group" aria-label="Filtrar por paradas">
            <div className={css`${item}`}>
                <Input
                  id="direct"
                  value="0"
                  type="checkbox"
                  label="Direto"
                  checked={selectedStops.includes(0)}
                  onChange={this.onCheckChange}
                />
            </div>
            <div className={css`${item}`}>
                <Input
                  id="1Stop"
                  value="1"
                  type="checkbox"
                  label="1 Parada"
                  checked={selectedStops.includes(1)}
                  onChange={this.onCheckChange}
                />
            </div>
            <div className={css`${item}`}>
                <Input
                  id="2Stops"
                  value="2"
                  type="checkbox"
                  label="2 Paradas"
                  checked={selectedStops.includes(2)}
                  onChange={this.onCheckChange}
                />
            </div>
            <div className={css`${item}`}>
                <Input
                  id="3Stops"
                  value="3"
                  type="checkbox"
                  label="3 Paradas"
                  checked={selectedStops.includes(3)}
                  onChange={this.onCheckChange}
                />
            </div>
            <div className={css`${item}`}>
                <Input
                  id="all"
                  value="all"
                  type="checkbox"
                  checked={selectedStops.length === 0}
                  label="Todas"
                  onChange={this.onCheckChange}
                />
            </div>
        </Dropdown>
      );
    }
  }

export default StopsDropdown
  